<template>
  <div class="pagination" v-if="totalPages > 1">
    <ul class="pages">
      <li
        v-if="currentPage !== 1"
        class="wide left"
        @click="prevPage"
      >
        {{ $tr('common.list.previous') }}
      </li>
      <li
        v-for="(page, i) in list"
        :key="i"
        :class="{ active: currentPage === page, first: page === 1, last: page === list.length }"
        @click="changePage(page)"
      >
        {{ page }}
      </li>
      <li
        v-if="(currentPage) !== totalPages"
        class="wide right"
        @click="nextPage"
      >
        {{ $tr('common.list.next') }}
      </li>
    </ul>
  </div>
</template>

<script>
  export default {
    name: 'pagination',

    props: {
      params: Object,
      onPageChange: Function,
      // Limits Selector
      needSelector: Boolean,
      onLimitChange: Function,
      multiselectCssClass: String,
      limitsSelectorTitle: String
    },

    computed: {
      totalPages () {
        return this.params ? this.params.totalPages : 1
      },

      currentPage () {
        return this.params ? this.params.pageNumber : 1
      },

      list () {
        const arr = []
        const page = this.currentPage
        const totalPages = this.totalPages

        let leftBoundry = Math.max(1, page - 1)
        let rightBoundry = Math.min(totalPages, page + 1)

        const emptyRight = 1 - (rightBoundry - page)
        const emptyLeft = 1 - (page - leftBoundry)

        leftBoundry = Math.max(1, leftBoundry - emptyRight)
        rightBoundry = Math.min(totalPages, rightBoundry + emptyLeft)

        for (let i = leftBoundry; i <= rightBoundry; i++) {
          arr.push(i)
        }

        return arr
      }
    },

    methods: {
      nextPage () {
        if (this.currentPage === this.totalPages) {
          return
        }
        this.changePage(this.currentPage + 1)
      },

      prevPage () {
        if (this.currentPage === 1) {
          return
        }
        this.changePage(this.currentPage - 1)
      },

      changePage (page) {
        this.onPageChange(page)
      }
    }
  }
</script>
